<template>
  <SearchMode v-if="mode === 'search'" />
  <DialpadMode v-else />
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SearchMode from './SearchMode/SearchMode'
import DialpadMode from './DialpadMode/DialpadMode'

const { mapState, mapActions } = createNamespacedHelpers('dialer')

export default {
  components: {
    SearchMode,
    DialpadMode
  },
  props: [
    'features'
  ],
  computed: {
    ...mapState([
      'mode'
    ])
  },
  created () {
    this.setFeatures(this.features)

    this.setModeFromQuery()

    this.setPhoneFromQuery()
  },
  methods: {
    ...mapActions([
      'setFeatures',
      'setMode',
      'setNumber'
    ]),
    setModeFromQuery () {
      const mode = this.$route.query.mode

      if (mode) {
        this.setMode(mode)
      }
    },
    setPhoneFromQuery () {
      const phoneNumber = this.$route.query.phoneNumber

      if (phoneNumber) {
        this.setNumber(decodeURIComponent(phoneNumber))
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SearchContacts.vue?43ce3f17